export const languageOptions = {
  en: "us",
  de: "de",
  fr: "fr",
  cn: "cn",
};
